const testimonials = [
  {
    name: "Dr. Carolyn F.",
    location: "Metairie, LA",
    rating: 5,
    text: "I registered for a cardiology CME conference in Vienna in January and realized in March — four weeks before departure — that my passport had expired. I assumed I would have to cancel and forfeit my registration. Fast Passport Center processed my renewal in seven business days. I made the conference, earned my CME credits, and was back in Metairie by the following Sunday. Worth every penny and then some.",
    service: "Expedited Passport Renewal",
  },
  {
    name: "Thomas & Linda P.",
    location: "Metairie, LA",
    rating: 5,
    text: "My wife and I booked a Mediterranean cruise for our 40th anniversary — 15-night sailing from Barcelona. When we went to gather our documents, I discovered my passport had expired during COVID and I had completely forgotten. We were 10 weeks from sailing. Fast Passport Center handled everything, we shipped our documents overnight from Metairie, and my passport arrived in eight days. The cruise was everything we hoped for.",
    service: "Emergency Renewal — Anniversary Cruise",
  },
  {
    name: "Jason K.",
    location: "Elmwood, LA — Energy Consulting",
    rating: 5,
    text: "I run a small energy consulting firm in Elmwood and was asked to join a client site visit in Calgary with two weeks notice. My passport had been expired for 16 months. Fast Passport Center walked me through the renewal process on the phone, I shipped my documents that afternoon, and had my passport in six business days. Made the trip, closed the deal. They are the definition of professional.",
    service: "Expedited Renewal — Business Travel",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function MetairieTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Metairie &amp; Jefferson Parish Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real stories from Metairie physicians, business executives, and retiring couples who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">&ldquo;{t.text}&rdquo;</p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}